(function () {
  // UK Bank Holidays (England & Wales) 2025 & 2026
  var UK_BANK_HOLIDAYS = [
    '2025-01-01', '2025-04-18', '2025-04-21', '2025-05-05', '2025-05-26',
    '2025-08-25', '2025-12-25', '2025-12-26',
    '2026-01-01', '2026-04-03', '2026-04-06', '2026-05-04', '2026-05-25',
    '2026-08-31', '2026-12-25', '2026-12-28',
    '2027-01-01', '2027-04-02', '2027-04-05', '2027-05-03', '2027-05-31',
    '2027-08-30', '2027-12-27', '2027-12-28'
  ];

  var DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var MONTHS = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];

  function isWorkingDay(date) {
    var day = date.getDay();
    if (day === 0 || day === 6) return false;
    var iso = date.getFullYear() + '-'
      + String(date.getMonth() + 1).padStart(2, '0') + '-'
      + String(date.getDate()).padStart(2, '0');
    return UK_BANK_HOLIDAYS.indexOf(iso) === -1;
  }

  function addWorkingDays(baseDate, daysToAdd) {
    var count = 0;
    var date = new Date(baseDate.getTime());
    while (count < daysToAdd) {
      date.setDate(date.getDate() + 1);
      if (isWorkingDay(date)) count++;
    }
    return date;
  }

  // Shop time is UK time, whatever the visitor's own clock says.
  function ukNow() {
    var parts = {};
    new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
    }).formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });
    return {
      date: new Date(+parts.year, +parts.month - 1, +parts.day),
      hour: +parts.hour,
      minute: +parts.minute
    };
  }

  function formatDate(date) {
    return DAYS[date.getDay()] + ' ' + date.getDate() + ' ' + MONTHS[date.getMonth()];
  }

  function initDeliveryEstimate(el) {
    var earliestDays = parseInt(el.dataset.earliest, 10);
    var latestDays = parseInt(el.dataset.latest, 10);
    var backInStock = el.dataset.backInStock;
    var cutoffHour = parseInt(el.dataset.cutoffHour, 10) || 12;

    if (isNaN(earliestDays) || isNaN(latestDays)) return;

    var now = ukNow();
    var baseDate = new Date(now.date.getTime());

    if (backInStock) {
      // Count working days from back-in-stock date
      baseDate = new Date(backInStock + 'T00:00:00');
    } else {
      // If order placed after cutoff, start counting from tomorrow
      if (now.hour >= cutoffHour) {
        baseDate.setDate(baseDate.getDate() + 1);
      }
    }

    var fromDate = addWorkingDays(baseDate, earliestDays);
    var toDate = addWorkingDays(baseDate, latestDays);

    var datesEl = el.querySelector('.delivery-estimate__dates');
    if (datesEl) {
      var formattedDates;
      if (fromDate.toDateString() === toDate.toDateString()) {
        formattedDates = formatDate(fromDate);
      } else {
        formattedDates = formatDate(fromDate) + ' \u2013 ' + formatDate(toDate);
      }
      datesEl.textContent = formattedDates;

      // Keep every delivery FAQ tied to the same calculated dates as the bullet above.
      document.querySelectorAll('.delivery-faq__dates').forEach(function (faqDatesEl) {
        faqDatesEl.textContent = formattedDates;
      });
    }

    var urgencyEl = el.querySelector('.delivery-estimate__urgency');

    // Made-to-order Leil saunas: no "dispatch today" countdown (kits and stock items only).
    if (el.dataset.madeToOrder === 'true') return;

    // Urgency message — only shown when no back-in-stock override
    if (urgencyEl && !backInStock && isWorkingDay(now.date)) {
      var nowMins = now.hour * 60 + now.minute;
      var cutoffMins = cutoffHour * 60;
      if (nowMins < cutoffMins) {
        var remaining = cutoffMins - nowMins;
        var h = Math.floor(remaining / 60);
        var m = remaining % 60;
        var msg;
        if (h > 0 && m > 0) {
          msg = 'Order in ' + h + 'h ' + m + 'm for dispatch today';
        } else if (h > 0) {
          msg = 'Order in ' + h + (h === 1 ? ' hour' : ' hours') + ' for dispatch today';
        } else {
          msg = 'Order in ' + m + (m === 1 ? ' min' : ' mins') + ' for dispatch today';
        }
        urgencyEl.textContent = msg;
        urgencyEl.style.display = 'block';
      }
    }
  }

  function init() {
    document.querySelectorAll('.delivery-estimate[data-earliest]').forEach(initDeliveryEstimate);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
